// extracted by mini-css-extract-plugin
export default {"container":"CDalx","large":"PFkwz","flush":"_iYbZ","topPadding":"HNc8l","bottomMargin":"pBGVe"};